import React from "react";

export const LazyCreateOfferPage = React.lazy(
  () => import("modules/projectRole/pages/RoundsPage/pages/CreateOfferPage"),
);
